import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Kontakt = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch('http://localhost:5000/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        alert('Nachricht erfolgreich gesendet!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('Fehler: ' + result.error);
      }
    } catch (err) {
      console.error('Serververbindung fehlgeschlagen:', err);
      alert('Verbindung zum Server fehlgeschlagen.');
    }
  };

  return (
    <div className="bg-gradient-to-b from-black via-gray-900 to-black text-white min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-start mt-10">
        <div>
          <h2 className="text-4xl font-extrabold text-fuchsia-500 mb-6">Kontaktiere uns</h2>
          <p className="text-gray-300 text-lg mb-8">
            Du hast ein Projekt oder Fragen? Schreib uns einfach eine Nachricht!
          </p>
          <div className="space-y-4 text-gray-400 text-md">
            <div className="flex items-center gap-3">
              <Mail className="text-fuchsia-500" size={20} />
              <span>info@netmoove.de</span>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="text-fuchsia-500" size={20} />
              <span>+49 1577 3537568</span>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="text-fuchsia-500" size={20} />
              <span>Köln, Deutschland</span>
            </div>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white/5 p-8 rounded-2xl border border-gray-700 space-y-5 shadow-xl backdrop-blur-md"
        >
          <input
            type="text"
            name="name"
            placeholder="Dein Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="bg-black/30 border border-gray-600 p-4 rounded-xl w-full text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
          />
          <input
            type="email"
            name="email"
            placeholder="Deine E-Mail"
            value={formData.email}
            onChange={handleChange}
            required
            className="bg-black/30 border border-gray-600 p-4 rounded-xl w-full text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
          />
          <textarea
            name="message"
            placeholder="Deine Nachricht..."
            rows="6"
            value={formData.message}
            onChange={handleChange}
            required
            className="bg-black/30 border border-gray-600 p-4 rounded-xl w-full text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-500"
          />
          <button
            type="submit"
            className="bg-fuchsia-600 hover:bg-fuchsia-700 px-8 py-4 rounded-full font-semibold transition-all duration-300"
          >
            Nachricht senden
          </button>
        </form>
      </div>

      <div className="mt-20 max-w-6xl mx-auto rounded-xl overflow-hidden border border-gray-700 shadow-lg">
        <iframe
          title="Unsere Adresse"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.9598791458426!2d13.40495461589589!3d52.52000627981253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a851c2f0210c69%3A0x9f5a8812749d47e4!2sBerlin%2C%20Germany!5e0!3m2!1sen!2sus!4v1680000000000"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Kontakt;
